import { Component, OnInit } from '@angular/core';
import { ExcelExportService } from 'projects/common/src/app/services/utils/excel-export.service';
import { ITableConfig } from '../../../../../../projects/common/src/app/interfaces/table/table-config';
import { ITableDataParams } from '../../../../../../projects/common/src/app/interfaces/table/table-data-params';
import { ITableHeaderParams } from '../../../../../../projects/common/src/app/interfaces/table/table-header-params';
import { ITableLargeColumnConfig } from '../../../../../../projects/common/src/app/interfaces/table/table-large-column-config';
import { TableConfigService } from '../../../../../../projects/common/src/app/services/table/table-config.service';
import { excelExportDateFormat } from '../../../../../../projects/common/src/app/services/utils/util.service';
import { IFilterConfig } from '../../../core/interfaces/filter-config';
import { IOutputFilter } from '../../../core/interfaces/output-filter';
import { GoogleAnalyticsService } from '../../../core/services/google/google-analytics.service';
import { ILayoutConfig } from '../../../layout/interfaces/layout-config';
import { LayoutConfigService } from '../../../layout/services/layout-config.service';
import { IReportMonthlyStatePerOperator } from '../../interfaces/report-monthly-state-per-operator';
import { ReportMonthlyStatePerOperatorService } from '../../services/report-monthly-state-per-operator.service';

@Component({
  selector: 'app-report-monthly-state-per-operator',
  templateUrl: './report-monthly-state-per-operator.component.html',
  styleUrls: ['./report-monthly-state-per-operator.component.scss'],
})
export class ReportMonthlyStatePerOperatorComponent implements OnInit {
  public selectedFilters: IOutputFilter;
  public params: IOutputFilter;
  public tableConfig: ITableConfig;
  public tableData: IReportMonthlyStatePerOperator[];
  public filterConfig: IFilterConfig;
  public btnSpinner: boolean;
  public disabledExcelBtn: boolean;

  constructor(
    private layoutConfigService: LayoutConfigService,
    private reportMonthlyStatePerOperatorService: ReportMonthlyStatePerOperatorService,
    private tableService: TableConfigService,
    private googleAnalyticsService: GoogleAnalyticsService,
    private _excelExportService: ExcelExportService,
  ) {
    this.filterConfig = {
      dates: { required: true },
      allMine: { required: true },
      cleanButton: true,
    };
    this.tableData = [];
    this.disabledExcelBtn = false;
  }

  ngOnInit(): void {
    const config: ILayoutConfig = {
      title: 'reports',
      subtitle: 'monthly-state-per-operator',
      imageKey: 'report',
      imageType: 'section',
    };

    this.layoutConfigService.setConfig(config);
  }

  /**
   * Function to get report data from received filters
   *
   * @param filters Filters selected to get data
   */
  public async getReportByFilters(selectedFilters: IOutputFilter): Promise<void> {
    this.filterConfig.isLoading = true;
    this.selectedFilters = selectedFilters;
    this.params = this.reportMonthlyStatePerOperatorService.setParams(selectedFilters);
    this.tableData = [];
    await this.reportMonthlyStatePerOperatorService
      .getReportMonthlyStatePerOperator(this.params)
      .then((resp) => {
        for (const element of resp) {
          this.tableData.push({
            operatorName: element.operatorName ? element.operatorName : null,
            statusName: element.statusName ? element.statusName : null,
            minutesPeriodFormat: element.minutesPeriodFormat ? element.minutesPeriodFormat : null,
            loopByPeriodFormat: element.loopByPeriodFormat ? element.loopByPeriodFormat : null,
            totalLoopsByOperator: element.totalLoopsByOperator,
          });
        }
      })
      .finally(() => {
        this.filterConfig.isLoading = false;
      });
    this.setTableConfig(this.tableData);
    const filters = {
      reports: 'report-monthly-state-per-operator',
    };
    this.googleAnalyticsService.sendCustomEvent('filter', filters);
  }

  /**
   * set table config
   */
  public setTableConfig(tableData: any[]): void {
    const customLargeColumns: ITableLargeColumnConfig[] = [
      { field: 'reportName', isLargeColumn: true },
      { field: 'userName', isLargeColumn: true },
      { field: 'downloadStartedAt', isLargeColumn: true },
      { field: 'downloadFinishedAt', isLargeColumn: true },
      { field: 'duration', isLargeColumn: true },
    ];
    const headerParams: ITableHeaderParams = {
      data: tableData,
      customLargeColumns,
      sortables: true,
    };

    const datasetParams: ITableDataParams = {
      tableData,
      customLargeColumns,
      dateConfig: [
        { field: 'downloadStartedAt', format: 'date-time' },
        { field: 'downloadFinishedAt', format: 'date-time' },
      ],
    };

    const { header, dataset } = this.tableService.setTableMainConfig(headerParams, datasetParams);

    this.tableConfig = { header, dataset };
  }

  /**
   * Function to download report
   */
  public async downloadReport(): Promise<void> {
    // const blobResponse = null;
    const selectRangeDate = {
      startDate: excelExportDateFormat(this.selectedFilters.startDate),
      endDate: excelExportDateFormat(this.selectedFilters.endDate),
    };

    this.btnSpinner = true;
    this.disabledExcelBtn = true;
    this.reportMonthlyStatePerOperatorService.getReportMonthlyStatePerOperatorExcel(this.selectedFilters).subscribe({
      next: (response) => {
        this._excelExportService.exportAsExcel(response, 'monthly-state-operator-report-filename', selectRangeDate, null, false);
        this.btnSpinner = false;
        this.disabledExcelBtn = false;
        this._excelExportService.messageToastSuccess();
      },
      error: (error) => {
        console.error(error);
        this.btnSpinner = false;
        this.disabledExcelBtn = false;
        this._excelExportService.messageToastError();
      },
    });
  }
}
